import React from 'react'
import PropTypes from 'prop-types'
import { Button, ErrorBlock } from 'antd-mobile'
import {
  withRouter
  // Link
} from 'react-router-dom'
import { Container, Header } from '../components_renew/Layout'

@withRouter
class NoMatch extends React.PureComponent {
  static propTypes = {
    title: PropTypes.string,
    message: PropTypes.string,
    buttonText: PropTypes.string,
    onButtonClick: PropTypes.func,
    forwardURL: PropTypes.string
  }
  static defaultProps = {
    title: '🙁页面不存在',
    message: '404 Not Found',
    buttonText: '返回'
  }

  render () {
    const { title, message, buttonText, onButtonClick } = this.props
    return <Container>
      <Header />
      <div>
        <ErrorBlock fullPage
                    title={message}
                    description={<div>
                      <div className={'mb-4'}>{title}</div>
                      <Button fill={'outline'}
                              color={'warning'}
                              size={'mini'}
                              onClick={onButtonClick ? onButtonClick : this.back}
                      >
                        <div className={'mx-8'}>{buttonText}</div>
                      </Button>
                    </div>}
        />
      </div>
    </Container>
  }

  back = () => {
    const { forwardUrl } = this.props
    if (forwardUrl) {
      this.props.history.push(this.props.forwardURL)
    } else {
      this.props.history.goBack()
    }
  }
}

export default NoMatch
